import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const PreConfirmPopup = (props) => {
    const { precheckAgreeButton, addCodeCancel, additionalPrecheckConfirmPopupText } = props.messages;
    return (
        <SimplePopup text={additionalPrecheckConfirmPopupText} handleClose={props.onClose}>
            <PopupButton iconName={'check'} text={precheckAgreeButton} onClick={props.payAgree} />
            <PopupButton iconName={'cross'} text={addCodeCancel} onClick={props.onClose} />
        </SimplePopup>
    );
};

export default PreConfirmPopup;
